import {
  defaultSystemCode,
  exists,
  LendGroupCount,
  LendGroupCountFromJSON,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface NowStatus {
  lendCountList: LendGroupCount[]
  lendLatestCount: number
  lendLatestLimit: number
  lendTotalCount: number
  lendTotalLimit: number
  insideReadingCount: number
  reserveCount: number
  lostCount: number
  hasOverdue: boolean
  suspendReason: SystemCode
  suspendLimit: string
  updatedDate: string
  lendDate: string
  remindDate: string
  remindExclude: SystemCode
  remindTotal: number
  remindWay: SystemCode
  overdueCount: number
}

export function NowStatusFromJSON(json: any): NowStatus {
  return {
    lendCountList: json.lend_count_list.map(LendGroupCountFromJSON),
    lendLatestCount: json.lend_latest_count,
    lendLatestLimit: json.lend_latest_limit,
    lendTotalCount: json.lend_total_count,
    lendTotalLimit: json.lend_total_limit,
    insideReadingCount: json.inside_reading_count,
    reserveCount: json.reserve_count,
    lostCount: json.lost_count,
    hasOverdue: json.has_overdue,
    suspendReason: exists(json, 'suspend_reason')
      ? SystemCodeFromJSON(json.suspend_reason)
      : defaultSystemCode(),
    suspendLimit: exists(json, 'suspend_limit')
      ? dateToPlainFormat(json.suspend_limit)
      : '',
    updatedDate: dateToPlainFormat(json.updated_date),
    lendDate: dateToPlainFormat(json.lend_date),
    remindDate: dateToPlainFormat(json.remind_date),
    remindExclude: exists(json, 'remind_exclude')
      ? SystemCodeFromJSON(json.remind_exclude)
      : defaultSystemCode(),
    remindTotal: json.remind_total,
    remindWay: exists(json, 'remind_way')
      ? SystemCodeFromJSON(json.remind_way)
      : defaultSystemCode(),
    overdueCount: json.overdue_count
  }
}

export const defaultNowStatus = (): NowStatus => ({
  lendCountList: [],
  lendLatestCount: 0,
  lendLatestLimit: 0,
  lendTotalCount: 0,
  lendTotalLimit: 0,
  insideReadingCount: 0,
  reserveCount: 0,
  lostCount: 0,
  hasOverdue: false,
  suspendReason: defaultSystemCode(),
  suspendLimit: '',
  updatedDate: '',
  lendDate: '',
  remindDate: '',
  remindExclude: defaultSystemCode(),
  remindTotal: 0,
  remindWay: defaultSystemCode(),
  overdueCount: 0
})
